import { render, staticRenderFns } from "./WeekPicker.vue?vue&type=template&id=b8d4affa&"
import script from "./WeekPicker.vue?vue&type=script&lang=ts&"
export * from "./WeekPicker.vue?vue&type=script&lang=ts&"
import style0 from "./WeekPicker.vue?vue&type=style&index=0&id=b8d4affa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports